import React, { useContext } from 'react';
import { FormContext } from '../../context/EquipmentFormContext';
import { LuCpu } from 'react-icons/lu';

// ============================================================
// DROPDOWN OPTIONS
// ============================================================

const sensorTypeOptions = [
  'Temperature',
  'Humidity',
  'Temperature & Humidity',
  'Pressure',
  'Door / Contact',
  'Energy Consumption',
  'Water Leakage',
  'Motion',
  'Vibration',
  'Other',
];

const connectionStatusOptions = [
  'Live',
  'Connected',
  'Disconnected',
  'Offline',
  'Warning',
  'Maintenance',
];

export default function Step7() {
  const { formData, updateField } = useContext(FormContext);

  const sensorDisabled = formData.sensorInstalled === 'No';

  return (
    <div className="bg-white rounded-xl border border-slate-100 p-6 shadow-sm">

      {/* ========================================================
          HEADER
      ======================================================== */}

      <div className="flex items-start space-x-4 mb-6">

        <div className="p-2 bg-blue-600 rounded-lg text-white">
          <LuCpu className="w-5 h-5 stroke-[2.5]" />
        </div>

        <div>

          <div className="flex items-center space-x-2">

            <span className="text-xs font-bold bg-blue-50 text-blue-700 px-1.5 py-0.5 rounded">
              7
            </span>

            <h2 className="text-base font-bold text-indigo-950">
              IoT / Sensor Setup
            </h2>

          </div>

          <p className="text-xs text-slate-500 mt-0.5">
            Add sensor details if this equipment is monitored via IoT.
          </p>

        </div>

      </div>

      {/* ========================================================
          SENSOR DETAILS
      ======================================================== */}

      <div className="grid grid-cols-1 md:grid-cols-5 gap-4 items-end">

        {/* ======================================================
            SENSOR INSTALLED
        ====================================================== */}

        <div>

          <label className="block text-xs font-semibold text-slate-700 mb-2">
            Sensor Installed?
          </label>

          <div className="flex items-center space-x-4 h-9">

            <label className="flex items-center text-sm font-semibold text-slate-800 cursor-pointer">

              <input
                type="radio"
                name="sensor_installed"
                checked={
                  formData.sensorInstalled === 'Yes'
                }
                onChange={() =>
                  updateField(
                    'sensorInstalled',
                    'Yes'
                  )
                }
                className="w-4 h-4 text-blue-600 border-slate-300"
              />

              <span className="ml-2">
                Yes
              </span>

            </label>

            <label className="flex items-center text-sm font-semibold text-slate-800 cursor-pointer">

              <input
                type="radio"
                name="sensor_installed"
                checked={
                  formData.sensorInstalled === 'No'
                }
                onChange={() =>
                  updateField(
                    'sensorInstalled',
                    'No'
                  )
                }
                className="w-4 h-4 text-blue-600 border-slate-300"
              />

              <span className="ml-2">
                No
              </span>

            </label>

          </div>

        </div>

        {/* ======================================================
            SENSOR TYPE
        ====================================================== */}

        <div>

          <label className="block text-xs font-semibold text-slate-700 mb-1">
            Sensor Type
          </label>

          <select
            value={formData.sensorType}
            onChange={(e) =>
              updateField(
                'sensorType',
                e.target.value
              )
            }
            disabled={sensorDisabled}
            className="w-full text-sm border border-slate-200 rounded-lg px-3 py-2 text-slate-800 bg-white focus:outline-none focus:ring-2 focus:ring-blue-100 disabled:bg-slate-50 disabled:text-slate-400"
          >

            <option value="">
              Select type
            </option>

            {sensorTypeOptions.map((type) => (
              <option
                key={type}
                value={type}
              >
                {type}
              </option>
            ))}

          </select>

        </div>

        {/* ======================================================
            SENSOR ID
        ====================================================== */}

        <div>

          <label className="block text-xs font-semibold text-slate-700 mb-1">
            Sensor ID / Reference
          </label>

          <input
            type="text"
            value={formData.sensorId}
            onChange={(e) =>
              updateField(
                'sensorId',
                e.target.value
              )
            }
            disabled={sensorDisabled}
            placeholder="e.g. SEN-001"
            className="w-full text-sm border border-slate-200 rounded-lg px-3 py-2 text-slate-800 focus:outline-none focus:ring-2 focus:ring-blue-100 disabled:bg-slate-50 disabled:text-slate-400"
          />

        </div>

        {/* ======================================================
            ALERT THRESHOLDS
        ====================================================== */}

        <div>

          <label className="block text-xs font-semibold text-slate-700 mb-1">
            Alert Thresholds
          </label>

          <input
            type="text"
            value={formData.alertThresholds}
            onChange={(e) =>
              updateField(
                'alertThresholds',
                e.target.value
              )
            }
            disabled={sensorDisabled}
            placeholder="e.g. 2°C to 8°C"
            className="w-full text-sm border border-slate-200 rounded-lg px-3 py-2 text-slate-800 focus:outline-none focus:ring-2 focus:ring-blue-100 disabled:bg-slate-50 disabled:text-slate-400"
          />

        </div>

        {/* ======================================================
            CONNECTION STATUS
        ====================================================== */}

        <div>

          <label className="block text-xs font-semibold text-slate-700 mb-1">
            Connection Status
          </label>

          <select
            value={formData.connectionStatus}
            onChange={(e) =>
              updateField(
                'connectionStatus',
                e.target.value
              )
            }
            disabled={sensorDisabled}
            className="w-full text-sm border border-slate-200 rounded-lg px-3 py-2 text-slate-800 bg-white focus:outline-none focus:ring-2 focus:ring-blue-100 disabled:bg-slate-50 disabled:text-slate-400"
          >

            <option value="">
              Select status
            </option>

            {connectionStatusOptions.map((status) => (
              <option
                key={status}
                value={status}
              >
                {status}
              </option>
            ))}

          </select>

        </div>

      </div>

    </div>
  );
}